import { FC } from 'react'
import classNames from 'classnames'
import { slugs } from '@/constants/slugs'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'

interface Props {
  isFooter?: boolean
}

const LOGO_SIZES: Record<string, { main: string; footer: string }> = {
  [slugs.homestead]: {
    main: 'w-[265px] h-[132px]',
    footer: 'w-[160px] h-[80px]',
  },
  [slugs.homesteadSeries]: {
    main: 'w-[265px]',
    footer: 'w-[160px]',
  },
  [slugs.braveTheDark]: {
    main: 'w-[129px] h-[60px] md:w-[185px] md:h-[88px] mb-2',
    footer: 'w-[101px] h-[48px]',
  },
  [slugs.ruleBreakers]: {
    main: 'w-[293px] h-[44px] md:w-[370px] md:h-[56px]',
    footer: 'w-[150px] h-[23px]',
  },
  'rule-breakers-tech': {
    main: 'w-[293px] h-[44px] md:w-[370px] md:h-[56px]',
    footer: 'w-[150px] h-[23px]',
  },
  [slugs.kingOfKings]: {
    main: 'w-[161px] h-[103px] md:w-[240px] md:h-[153px]',
    footer: 'w-[140px] h-[89px]',
  },
  [slugs.theLastRodeo]: {
    main: 'w-[201px] h-[58px] md:h-[94px] md:w-[327px]',
    footer: 'w-[142px] h-[41px]',
  },
  [slugs.sketch]: {
    main: 'w-[177px] h-[87px] md:h-[116px] md:w-[234px]',
    footer: 'w-[140px] h-[69px]',
  },
  [slugs.senior]: {
    main: 'w-[213px] h-[48px] md:h-[72px] md:w-[320px]',
    footer: 'w-[213px] h-[48px]',
  },
  [slugs.truthAndTreason]: {
    main: 'w-[133px] h-[96px] md:h-[152px] md:w-[210px]',
    footer: 'w-[150px] h-[108px]',
  },
  [slugs.david]: {
    main: 'w-[140px] h-[39px] md:h-[54px] md:w-[194px]',
    footer: 'w-[167] h-[46px]',
  },
  [slugs.youngWashington]: {
    main: 'w-[175px] h-[109px] md:h-[143px] md:w-[230px]',
    footer: 'w-[140px] h-[69px]',
  },
  [slugs.iWasAStranger]: {
    main: 'w-[164px] h-[50px] md:h-[66px] md:w-[216px]',
    footer: 'w-[152px] h-[46px]',
  },
  [slugs.soloMio]: {
    main: 'w-[345px] h-auto',
    footer: 'w-[152px] h-auto',
  },
}

export const GiveawayLogo: FC<Props> = ({ isFooter }) => {
  const { theatricalSlug, giveawayData } = useGiveawayContext()

  const getLogo = () => {
    if (isFooter && giveawayData.footerLogoUrl) {
      return giveawayData.footerLogoUrl
    }
    return giveawayData.logoUrl
  }

  const sizeClass = LOGO_SIZES[theatricalSlug]?.[isFooter ? 'footer' : 'main'] || ''

  return <img alt="logo" className={classNames('mx-auto md:mx-0', sizeClass, isFooter && '!mx-0')} src={getLogo()} />
}
